export default function Machines_C_3 (number = 1) {
  return {
    name: '采矿机',
    icon: '/static/img/machines/c3.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_C/Machines_C_3.js